const PAD_WIDTH = 2;

export const toLocalDateStr = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(PAD_WIDTH, "0");
  const day = String(date.getDate()).padStart(PAD_WIDTH, "0");
  return `${year}-${month}-${day}`;
};
